<template>
  <div
    class="company_add_sales_person-container company_add_sales_person-main AddSalesPerson-add-sales-person-container glass-tab-page company_add_sales_person-page--glass"
  >
    <BrucdcumHeader :breadcrumb="['Company', 'New Sales Person']" />

    <form class="company_add_sales_person-form" @submit.prevent>
      <div class="glass-tab-view glass-tab-view--flush company_add_sales_person-glass-shell">
        <div class="glass-tab-view__content company_add_sales_person-page-stack">
          <div class="company_add_sales_person-header-block">
            <h2 class="company_add_sales_person-title">New Sales Person</h2>
            <p class="company_add_sales_person-subtitle">
              Add contact details, expense account, and employment information
            </p>
          </div>

          <div
            class="company_add_sales_person-glass-panel glass-tab-panel glass-tab-panel--flex-column glass-tab-panel--stagger-rows"
          >
            <!-- Row 1: Name, Email, Phone -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--cols-3">
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-name"
                  label="Sales Person Name"
                  v-model="salesPersonName"
                  placeholder="Enter sales person name"
                  required
                  flex
                  :has-error="showErrors && !salesPersonName.trim()"
                >
                  <div v-if="showErrors && !salesPersonName.trim()" class="company_add_sales_person-error-text">
                    Sales person name is required
                  </div>
                </LabelInputField>
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-email"
                  label="Email"
                  v-model="email"
                  type="email"
                  autocomplete="email"
                  placeholder="salesperson@company.com"
                  required
                  flex
                  :has-error="showErrors && !email.trim()"
                >
                  <div v-if="showErrors && !email.trim()" class="company_add_sales_person-error-text">
                    Email is required
                  </div>
                </LabelInputField>
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-phone"
                  label="Phone"
                  v-model="phone"
                  type="tel"
                  placeholder="+1 (555) 123-4567"
                  required
                  flex
                  :has-error="showErrors && !phone.trim()"
                >
                  <div v-if="showErrors && !phone.trim()" class="company_add_sales_person-error-text">
                    Phone is required
                  </div>
                </LabelInputField>
              </div>
            </div>

            <!-- Row 2: File As, Job Title, Website -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--cols-3">
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-file-as"
                  label="File as"
                  v-model="fileAs"
                  placeholder="How should this be filed?"
                  flex
                />
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-job-title"
                  label="Job Title"
                  v-model="jobTitle"
                  placeholder="e.g., Sales Manager, Account Executive"
                  flex
                />
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-website"
                  label="Website"
                  v-model="webpage"
                  type="url"
                  placeholder="https://www.example.com"
                  flex
                />
              </div>
            </div>

            <!-- Row 3: Fax, Expense Account -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--cols-2">
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--input">
                <LabelInputField
                  input-id="add-sales-person-fax"
                  label="Fax"
                  v-model="fax"
                  type="tel"
                  placeholder="+1 (555) 123-4568"
                  flex
                />
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--dropdown">
                <LabelDropdown
                  label="Expense Account"
                  select-id="add-sales-person-expense-account"
                  v-model="expenseAccount"
                  flex
                  wide
                  searchable
                  search-placeholder="Search accounts..."
                  :options="expenseAccountDropdownOptions"
                  @change="handleExpenseAccountChange"
                />
              </div>
            </div>

            <!-- Row 4: Gender, Active -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--cols-2">
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--dropdown">
                <LabelDropdown
                  label="Gender"
                  select-id="add-sales-person-gender"
                  v-model="gender"
                  flex
                  wide
                  :searchable="false"
                  :options="genderDropdownOptions"
                />
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--checkbox">
                <LabelCheckboxField
                  input-id="add-sales-person-active"
                  label="Active"
                  v-model="active"
                  flex
                />
              </div>
            </div>

            <!-- Row 5: DOB, Date of Hire -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--cols-2">
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--date">
                <LabelDateField
                  input-id="add-sales-person-dob"
                  label="Date of Birth"
                  v-model="dob"
                  placeholder="MM/DD/YYYY"
                  flex
                />
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--date">
                <LabelDateField
                  input-id="add-sales-person-hire"
                  label="Date of Hire"
                  v-model="dateOfHire"
                  placeholder="MM/DD/YYYY"
                  flex
                />
              </div>
            </div>

            <!-- Row 6: Last Review, Release -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--cols-2">
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--date">
                <LabelDateField
                  input-id="add-sales-person-last-review"
                  label="Date of Last Review"
                  v-model="dateOfLastReview"
                  placeholder="MM/DD/YYYY"
                  flex
                />
              </div>
              <div class="company_add_sales_person-form-group company_add_sales_person-form-group--date">
                <LabelDateField
                  input-id="add-sales-person-release"
                  label="Date of Release"
                  v-model="dateOfRelease"
                  placeholder="MM/DD/YYYY"
                  flex
                />
              </div>
            </div>

            <!-- Row 7: Address -->
            <div class="glass-tab-panel__row company_add_sales_person-form-group-row company_add_sales_person-form-group-row--full">
              <div
                class="company_add_sales_person-form-group company_add_sales_person-form-group--description company_add_sales_person-address-field"
                role="button"
                tabindex="0"
                @click="handleAddressClick"
                @keydown.enter="handleAddressClick"
                @keydown.space.prevent="handleAddressClick"
              >
                <LabelDescriptionField
                  input-id="add-sales-person-address"
                  label="Address"
                  v-model="address"
                  :rows="3"
                  read-only
                  flex
                  placeholder="Click to enter address details"
                />
              </div>
            </div>
          </div>

          <div class="company_add_sales_person-form-actions glass-tab-view__actions">
            <SecondaryButton label="Cancel" :disabled="isLoading" @click="handleCancel" />
            <SecondaryButton
              label="Save and New"
              icon="bi bi-plus-circle"
              :disabled="isLoading"
              @click="handleSaveAndNew"
            />
            <PrimaryButton
              label="Save and Close"
              icon="bi bi-check-lg"
              :loading="isLoading"
              @click="handleSaveAndClose"
            />
          </div>
        </div>
      </div>
    </form>

    <AddressModal v-if="showAddressModal" :value="address" @ok="handleAddressOk" @cancel="handleAddressCancel" />
    <NewAccountCreationDialog
      :visible="showAccountModal"
      :companyId="getCompanyId()"
      @ok="handleAccountOk"
      @cancel="handleAccountCancel"
    />
    <ErrorModal
      :show="showErrorModal"
      :title="errorTitle"
      :message="errorMessage"
      @close="closeErrorModal"
    />
    <SuccessModal
      :show="showSuccessModal"
      :title="successTitle"
      :message="successMessage"
      @close="closeSuccessModal"
    />
  </div>
</template>

<script>
import '../styles/CompanyAddNewSalesPerson.css';
import logger from '@/utils/logger';
import AddressModal from './AddressModel.vue';
import NewAccountCreationDialog from './NewAccountCreationDialog.vue';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/SuccessModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import LabelDropdown from '@/modules/consultant/components/LabelDropdown.vue';
import LabelDateField from '@/modules/consultant/components/LabelDateField.vue';
import LabelCheckboxField from '@/modules/consultant/components/LabelCheckboxField.vue';
import LabelDescriptionField from '@/modules/consultant/components/LabelDescriptionField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';
import axios from 'axios';

export default {
  name: 'CompanyAddNewSalesPerson',
  components: {
    AddressModal,
    NewAccountCreationDialog,
    BrucdcumHeader,
    ErrorModal,
    SuccessModal,
    LabelInputField,
    LabelDropdown,
    LabelDateField,
    LabelCheckboxField,
    LabelDescriptionField,
    PrimaryButton,
    SecondaryButton,
  },
  data() {
    const today = new Date();
    const todayFormatted = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`;
    return {
      salesPersonName: '',
      fileAs: '',
      jobTitle: '',
      address: '',
      phone: '',
      fax: '',
      expenseAccount: '',
      expenseAccounts: [],
      email: '',
      webpage: '',
      active: true,
      gender: 'Unspecified',
      dob: '',
      dateOfHire: todayFormatted,
      dateOfLastReview: '',
      dateOfRelease: '',
      showAddressModal: false,
      showAccountModal: false,
      isLoading: false,
      showErrors: false,
      showErrorModal: false,
      errorTitle: 'Error',
      errorMessage: '',
      showSuccessModal: false,
      successTitle: 'Success',
      successMessage: '',
      navigateAfterSuccess: false,
    };
  },
  computed: {
    genderDropdownOptions() {
      return [
        { value: 'Unspecified', label: 'Unspecified' },
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' },
      ];
    },
    expenseAccountDropdownOptions() {
      const accounts = this.expenseAccounts.map((account) => ({
        value: account.id,
        label: `${account.accountName} (${account.accountNumber}) - ${account.accountType}`,
      }));
      return [
        { value: '', label: 'Select an expense account', disabled: true },
        ...accounts,
        { value: '__create_new__', label: 'Add New Account' },
      ];
    },
  },
  async created() {
    await this.fetchExpenseAccounts();
  },
  methods: {
    async fetchExpenseAccounts() {
      const companyId = this.getCompanyId();
      if (!companyId) return;

      try {
        const accRes = await axios.get(`/company-account/company/${companyId}`);
        this.expenseAccounts = (accRes.data.accounts || []).filter(
          (acc) => acc.accountType === 'Expense' || acc.accountType === 'Other Expense'
        );
      } catch (error) {
        logger.error('Failed to load expense accounts:', error);
        this.$toast?.error('Failed to load expense accounts');
      }
    },

    getCompanyId() {
      return this.$route?.params?.companyId || this.$route?.params?.id;
    },

    handleExpenseAccountChange(value) {
      if (value === '__create_new__') {
        this.showAccountModal = true;
        this.$nextTick(() => {
          this.expenseAccount = '';
        });
      }
    },

    handleAddressOk(addressData) {
      this.address = addressData || '';
      this.showAddressModal = false;
    },

    handleAddressCancel() {
      this.showAddressModal = false;
    },

    handleAddressClick() {
      if (!this.address || this.address.trim() === '') {
        this.errorTitle = 'Address Required';
        this.errorMessage = 'Please click to enter address details.';
        this.showErrorModal = true;
      }
      this.showAddressModal = true;
    },

    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },

    closeSuccessModal() {
      this.showSuccessModal = false;
      this.successMessage = '';
      if (this.navigateAfterSuccess) {
        this.navigateBack();
      }
    },

    async handleAccountOk(createdAccount) {
      this.showAccountModal = false;
      if (createdAccount) {
        await this.fetchExpenseAccounts();
        this.expenseAccount = createdAccount.id;
        if (this.$toast) {
          this.$toast.success('Account created successfully!');
        }
      }
    },

    handleAccountCancel() {
      this.showAccountModal = false;
    },

    validateForm() {
      this.showErrors = true;
      return (
        Boolean(this.salesPersonName.trim()) &&
        Boolean(this.email.trim()) &&
        Boolean(this.phone.trim())
      );
    },

    async handleSaveAndNew() {
      if (!this.validateForm()) {
        this.errorTitle = 'Validation Error';
        this.errorMessage = 'Please fill in all required fields.';
        this.showErrorModal = true;
        return;
      }

      this.isLoading = true;
      try {
        await this.saveSalesPerson();
        this.successTitle = 'Success';
        this.successMessage = 'Sales person saved successfully!';
        this.showSuccessModal = true;
        this.navigateAfterSuccess = false;
        this.resetForm();
        this.showErrors = false;
      } catch (error) {
        this.errorTitle = 'Save Failed';
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        } else if (error.response?.data?.errors) {
          this.errorMessage = Object.values(error.response.data.errors).join('\n');
        } else {
          this.errorMessage = 'Failed to save sales person. Please try again.';
        }
        this.showErrorModal = true;
      } finally {
        this.isLoading = false;
      }
    },

    async handleSaveAndClose() {
      if (!this.validateForm()) {
        this.errorTitle = 'Validation Error';
        this.errorMessage = 'Please fill in all required fields.';
        this.showErrorModal = true;
        return;
      }

      this.isLoading = true;
      try {
        await this.saveSalesPerson();
        this.successTitle = 'Success';
        this.successMessage = 'Sales person saved successfully!';
        this.showSuccessModal = true;
        this.navigateAfterSuccess = true;
      } catch (error) {
        this.errorTitle = 'Save Failed';
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        } else if (error.response?.data?.errors) {
          this.errorMessage = Object.values(error.response.data.errors).join('\n');
        } else {
          this.errorMessage = 'Failed to save sales person. Please try again.';
        }
        this.showErrorModal = true;
      } finally {
        this.isLoading = false;
      }
    },

    async saveSalesPerson() {
      const companyId = this.getCompanyId();
      if (!companyId) {
        throw new Error('Company ID not found');
      }

      let addressObj = null;
      if (this.address && this.address.trim()) {
        const lines = this.address.split('\n');
        const paddedLines = [...lines, '', '', '', '', '', ''].slice(0, 6);
        addressObj = {
          address1: paddedLines[0] || '',
          address2: paddedLines[1] || '',
          city: paddedLines[2] || '',
          state: paddedLines[3] || '',
          postalCode: paddedLines[4] || '',
          country: paddedLines[5] || '',
        };
      }

      const payload = {
        salesPersonName: this.salesPersonName.trim(),
        fileAs: this.fileAs.trim(),
        jobTitle: this.jobTitle.trim(),
        phone: this.phone.trim(),
        fax: this.fax.trim(),
        expenseAccountId: this.expenseAccount || null,
        email: this.email.trim(),
        webpage: this.webpage.trim(),
        active: this.active,
        gender: this.gender,
        dob: this.convertDateToISO(this.dob),
        dateOfHire: this.convertDateToISO(this.dateOfHire),
        dateOfLastReview: this.convertDateToISO(this.dateOfLastReview),
        dateOfRelease: this.convertDateToISO(this.dateOfRelease),
        companyId,
        address: addressObj,
      };

      const response = await axios.post(`/company/${companyId}/sales-persons`, payload);
      return response.data;
    },

    resetForm() {
      this.salesPersonName = '';
      this.fileAs = '';
      this.jobTitle = '';
      this.address = '';
      this.phone = '';
      this.fax = '';
      this.expenseAccount = '';
      this.email = '';
      this.webpage = '';
      this.active = true;
      this.gender = 'Unspecified';
      this.dob = '';
      const today = new Date();
      this.dateOfHire = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`;
      this.dateOfLastReview = '';
      this.dateOfRelease = '';
      this.showErrors = false;
    },

    navigateBack() {
      const companyId = this.getCompanyId();
      if (companyId) {
        this.$router.push(`/company/${companyId}/dashboard`);
      } else {
        this.$router.push('/dashboard');
      }
    },

    handleCancel() {
      this.navigateBack();
    },

    convertDateToISO(dateString) {
      if (!dateString) return null;

      const parts = dateString.split('/');
      if (parts.length !== 3) return null;

      const month = parts[0];
      const day = parts[1];
      const year = parts[2];

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};
</script>
